import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, ArrowLeft, Download } from "lucide-react";
import { Button } from "@/components/ui/button";

const COLS = [
  { k: "name", h: "Name" },
  { k: "date_ist", h: "Date (IST)" },
  { k: "brand_id", h: "BrandId" },
  { k: "deposit_count_before", h: "Cnt Before" },
  { k: "deposit_sum_before", h: "Sum Before" },
  { k: "last_deposit_date_before", h: "Last Before" },
  { k: "days_since_last_deposit_before", h: "Days Since" },
  { k: "first_deposit_on_day_date", h: "First On" },
  { k: "first_deposit_on_day_amount", h: "First On Amt" },
  { k: "deposit_on_day_amount", h: "On Day Amt" },
  { k: "deposit_on_day_count", h: "On Day Cnt" },
  { k: "deposit_count_after", h: "Cnt After" },
  { k: "deposit_sum_after", h: "Sum After" },
  { k: "last_deposit_date_after", h: "Last After" },
];

export default function ReportDetailPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/reports/${id}`).then((r) => setData(r.data));
  }, [id]);

  const download = async () => {
    const r = await api.get(`/reports/${id}/download`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([r.data]));
    const a = document.createElement("a");
    a.href = url;
    a.download = data?.meta?.filename || "report.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  if (!data) return <div className="p-8 flex justify-center"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  const meta = data.meta;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <Link to="/reports" className="text-xs text-slate-500 inline-flex items-center gap-1 mb-1">
            <ArrowLeft className="w-3 h-3" /> Back to reports
          </Link>
          <h1 className="font-outfit font-semibold text-2xl md:text-3xl text-slate-900">{meta.team_name} · {meta.month}</h1>
          <div className="text-xs text-slate-500 mt-1">{meta.row_count} rows · {meta.source} · {meta.filename}</div>
        </div>
        <Button onClick={download} className="btn-tactile"><Download className="w-4 h-4 mr-2" /> Excel</Button>
      </div>

      <div className="glass-card p-3 overflow-x-auto">
        <table className="w-full text-xs">
          <thead>
            <tr className="text-slate-500">
              {COLS.map((c) => <th key={c.k} className="text-left py-2 px-2 whitespace-nowrap">{c.h}</th>)}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.id} className="border-t border-white/50 hover:bg-white/50">
                {COLS.map((c) => (
                  <td key={c.k} className="py-1.5 px-2 whitespace-nowrap">
                    {r[c.k] === null || r[c.k] === undefined ? "—" : String(r[c.k])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
